import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "input-toolbar-h5" }
const _hoisted_2 = { key: 0 }

import vue from '../../adapter-vue';
import {
  IMessageModel,
  StoreName,
  TUIChatEngine,
  TUIConversationService,
  TUIStore,
  TUITranslateService,
} from '../../@aidesk/uikit-engine';
import ChatHeader from './chat-header/index-web.vue';
import MessageList from './message-list/index-web.vue';
import MessageInput from './message-input/index-web.vue';
import MessageInputToolbar from './message-input-toolbar/index-web.vue';
import EmojiDialog from './message-input-toolbar/emoji-dialog-mobile/emoji-dialog-mobile.vue';
import { isH5, isPC } from '../../utils/env';
import { ToolbarButtonModel, ToolbarDisplayType, InputToolbarModel, QuickOrderModel, IHeaderConfig, IMessageToolDisplayConfig } from '../../interface';
import Log from '../../utils/logger';
import MessageToolbarButton from './message-toolbar-button/index.vue';
import TUILocales from '../../locales';
import state from '../../utils/state.js';
import { switchReadStatus, isNonEmptyObject } from '../../utils/utils';
import { getCountryForTimezone } from 'countries-and-timezones';
import FeedbackModal from './feedback-modal/index.vue';
import CustomerQueuePage from './customer-queue-page/index.vue';
import { startHeartbeat, stopHeartbeat, sendHeartbeat } from '../../utils/heartbeat-handler';
interface IProps {
  canCloseChat?: boolean;
  SDKAppID?: number;
  userID?: string;
  userSig?: string;
  robotLang?: string;
  userLang?: string;
  toolbarButtonList?: ToolbarButtonModel[];
  showAvatar?: number;
  robotAvatar?: string;
  memberAvatar?: string;
  userAvatar?: string;
  showNickName?: number;
  robotNickName?: string;
  memberNickName?: string;
  userNickName?: string;
  enableUnifiedMemberProfile?: number;
  inputToolbarList?: InputToolbarModel[];
  showReadStatus?: number;
  showTyping?: number;
  bottomQuickOrder?: QuickOrderModel;
  enableMultilingual?: number;
  langList?: Array<string>;
  enableFeedback?: number;
  enableAINote?: number;
  enableURLDetection?: number;
  headerConfig?: IHeaderConfig;
  enableSendingAudio?: number;
  showQueuePage?: number;
  showAllRobotWelcomeItems?: number;
  messageToolDisplayConfig?: IMessageToolDisplayConfig[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index-web',
  props: {
    canCloseChat: { type: Boolean, default: true },
    SDKAppID: { default: 0 },
    userID: { default: '' },
    userSig: { default: '' },
    robotLang: { default: '' },
    userLang: { default: '' },
    toolbarButtonList: {},
    showAvatar: { default: 1 },
    robotAvatar: { default: '' },
    memberAvatar: { default: '' },
    userAvatar: { default: '' },
    showNickName: { default: 0 },
    robotNickName: { default: '' },
    memberNickName: { default: '' },
    userNickName: { default: '' },
    enableUnifiedMemberProfile: { default: 1 },
    inputToolbarList: {},
    showReadStatus: { default: 1 },
    showTyping: { default: 0 },
    bottomQuickOrder: {},
    enableMultilingual: { default: 0 },
    langList: { default: () => [] },
    enableFeedback: { default: 0 },
    enableAINote: { default: 1 },
    enableURLDetection: { default: 0 },
    headerConfig: {},
    enableSendingAudio: { default: 0 },
    showQueuePage: { default: 0 },
    showAllRobotWelcomeItems: { default: 0 },
    messageToolDisplayConfig: {}
  },
  emits: ['closeChat'],
  setup(__props: any, { emit: __emit }) {

const { ref, onMounted, onUnmounted, computed } = vue;

const emits = __emit;

const currentConversationID = ref();
const inputToolbarDisplayType = ref<ToolbarDisplayType>('none');
const messageInputRef = ref();
const isMuted = ref(false);
const muteText = ref('');
const messageListRef = ref<InstanceType<typeof MessageList>>();
const emojiOpen = ref(false);
const toolShowH5 = ref(false);
const languages = Object.keys(TUILocales);
const quoteMessage = ref<IMessageModel>();
const showBottomQuickOrder = ref(false);
const currentLanguage = ref('');
const languageForShowList = ref<Array<string>>([]);
const feedbackModalRef = ref();
const showFeedbackModal = ref(false);
const queueNumber = ref(-1); 
const queueLeavePageTimeoutEnable = ref(false);
const hasLeftQueue = ref(false);
let timezone = '';
let countryID = '';
const props = __props;

const getTimeZoneAndCountry = () => {
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const country = getCountryForTimezone(timezone);
  countryID = country && country.id ? country.id : '';
}

const convertLanguageToLowercase = (language) => {
  let lowercase = language.toLowerCase();
  if (lowercase === 'zh-cn' || lowercase === 'zh_cn') {
    lowercase = 'zh';
  } else if (lowercase === 'zh-tw' || lowercase === 'zh-hk') {
    lowercase = 'zh_tw';
  }
  return lowercase;
}

const getValidLanguage = (language: string) => {
  let validLanguage = '';
  if (props.enableMultilingual === 1 && languageForShowList.value.length !== 0) {
    if (languageForShowList.value.includes(language)) {
      validLanguage = language;
    } else {
      // choose default language (languageForShowList.value[0] for uikit) if language is not supported
      validLanguage = languageForShowList.value[0];
    }
  } else if (languages.includes(language)) {
    validLanguage = language;
  } else {
    if (props.userLang !== ''){
      Log.w(`userLang:${props.userLang} is not supported`);
    }
    validLanguage = 'en';
  }
  return validLanguage;
}

const initLanguage = () => {
  Log.i(`initLanguage ${props.userLang}`);
  TUITranslateService.provideLanguages({ ...TUILocales });
  TUITranslateService.useI18n();
  if (props.enableMultilingual === 1) {
    languageForShowList.value = props.langList.filter(language => languages.includes(language));
  }
  let language;
  try {
    const prevLanguage = localStorage.getItem('AIDesk_language');
    if (prevLanguage) {
      language = prevLanguage;
    }
  } catch {
    Log.w('No Previous Language');
  }
  if (!language) {
    if (props.userLang !== '') {
      let userLang = convertLanguageToLowercase(props.userLang);
      language = getValidLanguage(userLang);
    } else {
      let navigatorLang = convertLanguageToLowercase(navigator.language);
      language = getValidLanguage(navigatorLang);
    }
  }
  currentLanguage.value = language;
  state.set('currentLanguage', language);
  TUITranslateService.changeLanguage(language);
}

const setAvatarNickName = () => {
  state.set('avatarNickName', {
    showAvatar: props.showAvatar,
    showNickName: props.showNickName,
    userAvatar: props.userAvatar,
    memberAvatar: props.memberAvatar,
    robotAvatar: props.robotAvatar,
    userNickName: props.userNickName,
    memberNickName: props.memberNickName,
    robotNickName: props.robotNickName,
    enableUnifiedMemberProfile: props.enableUnifiedMemberProfile,
  });
}

const setShowReadStatus = () => {
  state.set('showReadStatus', props.showReadStatus);
}

const setShowTyping = () => {
  state.set('showTyping', props.showTyping);
}

const setEnableURLDetection = () => {
  state.set('enableURLDetection', props.enableURLDetection);
}

const setShowAllRobotWelcomeItems = () => {
  state.set('showAllRobotWelcomeItems', props.showAllRobotWelcomeItems);
}

const setMessageToolDisplayConfig = () => {
  state.set('messageToolDisplayConfig', props.messageToolDisplayConfig || []);
}

try {
  initLanguage();
  setAvatarNickName();
  setShowReadStatus();
  setShowTyping();
  setEnableURLDetection();
  setShowAllRobotWelcomeItems();
  getTimeZoneAndCountry();
  setMessageToolDisplayConfig();
  if (isNonEmptyObject(props.bottomQuickOrder)) {
    showBottomQuickOrder.value = true;
  }
} catch (e) {
  console.log(e)
}

onMounted(() => {
  // 如果组件挂载在 sdk login 之后，需再次设置 displayMessageReadReceipt，确保状态准确
  if (TUIChatEngine.isReady()) {
    switchReadStatus(state.get('showReadStatus'));
  }

  TUIStore.watch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdate,
  });
  TUIStore.watch(StoreName.USER, {
    kickedOut: onKickedOut
  });
  TUIStore.watch(StoreName.CHAT, {
    quoteMessage: onQuoteMessageUpdated,
  });
  TUIStore.watch(StoreName.CUSTOM, {
    isQueuing: onIsQueuingUpdate,
    queueLeavePageTimeoutEnable: onQueueLeavePageTimeoutEnable,
  });
  document.addEventListener('visibilitychange', handleVisibilityChange);
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdate,
  });
  TUIStore.unwatch(StoreName.USER, {
    kickedOut: onKickedOut
  });
  TUIStore.unwatch(StoreName.CHAT, {
    quoteMessage: onQuoteMessageUpdated,
  });
  TUIStore.unwatch(StoreName.CUSTOM, {
    isQueuing: onIsQueuingUpdate,
    queueLeavePageTimeoutEnable: onQueueLeavePageTimeoutEnable,
  });
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  stopHeartbeat();
});

const isInputToolbarShow = computed<boolean>(() => {
  return (isH5) ? inputToolbarDisplayType.value !== 'none' : true;
});

const reset = () => {
  TUIConversationService.switchConversation('');
};

const closeChat = (conversationID: string) => {
  emits('closeChat', conversationID);
  reset();
};

const insertEmoji = (emojiObj: object) => {
  messageInputRef.value?.insertEmoji(emojiObj);
};
const sendMessage = () => {
  messageInputRef.value?.sendMessage();
}

const onMessageSent = () => {
  // 发送消息后列表滚动到底部
  messageListRef.value?.scrollToLatestMessage();
}

const handleEditor = (message: IMessageModel, type: string) => {
  if (!message || !type) return;
  switch (type) {
    case 'reference':
      // todo
      break;
    case 'reply':
      // todo
      break;
    case 'reedit':
      if (message?.payload?.text) {
        messageInputRef?.value?.reEdit(message?.payload?.text);
      }
      break;
    default:
      break;
  }
};

function changeToolbarDisplayType(type: ToolbarDisplayType) {
  inputToolbarDisplayType.value
    = inputToolbarDisplayType.value === type ? 'none' : type;
}

function scrollToLatestMessage() {
  messageListRef.value?.scrollToLatestMessage();
}

function onKickedOut(type: string) {
  if (type) {
    isMuted.value = true;
    muteText.value = TUITranslateService.t('TUIChat.账号被强制下线');
  }
}

function onCurrentConversationIDUpdate(conversationID: string) {
  if (!conversationID) {
    return;
  }

  currentConversationID.value = conversationID;
  activeConversation();
}

function emojiShow(){
  if(toolShowH5.value === true){
    toolShowH5.value = false;
  }
  emojiOpen.value = !emojiOpen.value;

}

function toolShow(){
  if(emojiOpen.value === true){
    emojiOpen.value = false;
  }
  toolShowH5.value = !toolShowH5.value;
}

function blurToolAndEmojiH5() {
  if (emojiOpen.value === true) {
    emojiOpen.value = false;
  }
  toolShowH5.value = false;
}

function onQuoteMessageUpdated(options?: {
  message: IMessageModel;
  type: string;
}) {
  if (options?.message && options?.type === 'quote') {
    quoteMessage.value = options.message;
  } else {
    quoteMessage.value = undefined;
  }
}

function closeBottomQuickOrder() {
  showBottomQuickOrder.value = false;
}

function changeLanguage(languageCode: string) {
  Log.l(`multilingual: change language to ${languageCode}`);
  TUITranslateService.changeLanguage(languageCode).then(() => {
    currentLanguage.value = languageCode;
    state.set('currentLanguage', languageCode);
    try {
      localStorage.setItem('AIDesk_language', languageCode);
    } catch {
      Log.w("Failed to set language to localStorage.");
    }
    activeConversation();
  });
}

function activeConversation() {
  TUIStore.update(StoreName.CUSTOM, 'activeConversation', {
    conversationID: currentConversationID.value,
    robotLang: props.robotLang && languages.includes(props.robotLang) ? props.robotLang : currentLanguage.value === 'zh_tw' ? 'zh-TW' : currentLanguage.value,
    country: countryID,
    timezone: timezone,
  });
}

function onLike(type: number, messageInfo: Object) {
  feedbackModalRef.value.onLike(type, messageInfo);
}

function onDislike(type: number, messageInfo: Object) {
  if (type === 2) {
    showFeedbackModal.value = true;
  }
  feedbackModalRef.value.onDislike(type, messageInfo);
}

function onIsQueuingUpdate(data: {conversationID: string, value: number}) {
  if (data && data.conversationID === currentConversationID.value) {
    queueNumber.value = data.value;
    hasLeftQueue.value = false;
    if (queueNumber.value >= 0) {
      startHeartbeat();
    } else {
      stopHeartbeat();
    }
  }
}

function onQueueLeavePageTimeoutEnable(data: boolean) {
  queueLeavePageTimeoutEnable.value = data;
  startHeartbeat();
}

const handleVisibilityChange = () => {
  if (document.visibilityState === 'hidden') {
    if (queueLeavePageTimeoutEnable.value && queueNumber.value >= 0) {
      sendHeartbeat(currentConversationID.value, "leaveSessionPage");
    }
    stopHeartbeat();
  } else if (document.visibilityState === 'visible') {
    startHeartbeat();
  }
}

function closeQueuePage() {
  hasLeftQueue.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5','ai-desk-customer']),
    key: _unref(currentLanguage)
  }, [
    (_unref(currentConversationID) && (!props.showQueuePage || _unref(queueNumber) < 0 || _unref(queueNumber) === undefined || _unref(hasLeftQueue)))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5','ai-desk-customer'])
        }, [
          _createVNode(ChatHeader, {
            class: _normalizeClass([
          'tui-chat-header',
          !_unref(isPC) && 'tui-chat-H5-header'
        ]),
            canCloseChat: props.canCloseChat,
            enableMultilingual: props.enableMultilingual,
            langList: _unref(languageForShowList),
            currentLang: _unref(currentLanguage),
            headerConfig: props.headerConfig,
            onCloseChat: closeChat,
            onChangeLanguage: changeLanguage
          }, null, 8, ["class", "canCloseChat", "enableMultilingual", "langList", "currentLang", "headerConfig"]),
          _createVNode(MessageList, {
            ref_key: "messageListRef",
            ref: messageListRef,
            class: _normalizeClass(['tui-chat-message-list', !_unref(isPC) && 'tui-chat-h5-message-list']),
            onHandleEditor: handleEditor,
            onCloseInputToolBar: _cache[0] || (_cache[0] = () => changeToolbarDisplayType('none')),
            bottomQuickOrder: props.bottomQuickOrder,
            showBottomQuickOrder: _unref(showBottomQuickOrder),
            onCloseBottomQuickOrder: closeBottomQuickOrder,
            enableFeedback: props.enableFeedback,
            enableAINote: props.enableAINote,
            onLike: onLike,
            onDislike: onDislike
          }, null, 8, ["class", "bottomQuickOrder", "showBottomQuickOrder", "enableFeedback", "enableAINote"]),
          (props.toolbarButtonList && (!_unref(isH5) || (!Boolean(_unref(quoteMessage)) && !_unref(showBottomQuickOrder))))
            ? (_openBlock(), _createBlock(MessageToolbarButton, {
                key: 0,
                toolbarButtonList: props.toolbarButtonList
              }, null, 8, ["toolbarButtonList"]))
            : _createCommentVNode("", true),
          (_unref(isInputToolbarShow))
            ? (_openBlock(), _createBlock(MessageInputToolbar, {
                key: 1,
                class: _normalizeClass([
          'tui-chat-message-input-toolbar',
          !_unref(isPC) && 'tui-chat-h5-message-input-toolbar'
        ]),
                displayType: _unref(inputToolbarDisplayType),
                inputToolbarList: props.inputToolbarList,
                onInsertEmoji: insertEmoji,
                onChangeToolbarDisplayType: changeToolbarDisplayType,
                onScrollToLatestMessage: scrollToLatestMessage
              }, null, 8, ["class", "displayType", "inputToolbarList"]))
            : _createCommentVNode("", true),
          _createVNode(MessageInput, {
            ref_key: "messageInputRef",
            ref: messageInputRef,
            class: _normalizeClass([
          'tui-chat-message-input',
          !_unref(isPC) && 'tui-chat-h5-message-input'
        ]),
            isMuted: _unref(isMuted),
            muteText: _unref(muteText),
            placeholder: _unref(TUITranslateService).t('TUIChat.请输入消息'),
            inputToolbarDisplayType: _unref(inputToolbarDisplayType),
            inputToolbarList: props.inputToolbarList,
            enableSendingAudio: props.enableSendingAudio,
            onChangeToolbarDisplayType: changeToolbarDisplayType,
            onEmojiShow: emojiShow,
            onToolShow: toolShow,
            onBlurToolAndEmojiH5: blurToolAndEmojiH5,
            onMessageSent: onMessageSent
          }, null, 8, ["class", "isMuted", "muteText", "placeholder", "inputToolbarDisplayType", "inputToolbarList", "enableSendingAudio"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(['emoji-dialog-h5',(_unref(toolShowH5) && !_unref(emojiOpen))?'tool-dialog-h5':''])
            }, [
              (_unref(emojiOpen))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(EmojiDialog, {
                      onInsertEmoji: insertEmoji,
                      onSendMessage: sendMessage
                    })
                  ]))
                : _createCommentVNode("", true),
              (!_unref(isPC))
                ? (_openBlock(), _createBlock(MessageInputToolbar, {
                    key: 1,
                    class: _normalizeClass([
              'tui-chat-message-input-toolbar',
              !_unref(isPC) && 'tui-chat-h5-message-input-toolbar'
            ]),
                    isH5ToolShow: _unref(toolShowH5),
                    displayType: _unref(inputToolbarDisplayType),
                    inputToolbarList: props.inputToolbarList,
                    onInsertEmoji: insertEmoji,
                    onChangeToolbarDisplayType: changeToolbarDisplayType,
                    onScrollToLatestMessage: scrollToLatestMessage,
                    onSendMessage: sendMessage
                  }, null, 8, ["class", "isH5ToolShow", "displayType", "inputToolbarList"]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _withDirectives(_createVNode(FeedbackModal, {
            ref_key: "feedbackModalRef",
            ref: feedbackModalRef,
            onClose: _cache[1] || (_cache[1] = () => { showFeedbackModal.value = false })
          }, null, 512), [
            [_vShow, _unref(showFeedbackModal)]
          ])
        ], 2))
      : _createCommentVNode("", true),
    (props.showQueuePage && _unref(queueNumber) >= 0 && !_unref(hasLeftQueue))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5'])
        }, [
          _createVNode(CustomerQueuePage, {
            queueNumber: _unref(queueNumber),
            onCloseQueuePage: closeQueuePage
          }, null, 8, ["queueNumber"])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})